export const settingscolumns = [
  { id: 'from', label: 'Voucher Type', maxWidth: 220 },
  { id: 'to', label: 'Voucher Numbering', maxWidth: 280 },
  { id: 'id', label: 'S.No.', maxWidth: 100 },
  // { id: "SerialIsActive", label: "Status", maxWidth: 50 },
  { id: 'Prefix', label: 'Prefix', maxWidth: 150 },
  {
    id: 'startinvoicenumber',
    label: 'Start Number',
    maxWidth: 150,
  },

  {
    id: 'Suffix',
    label: 'Suffix',
    maxWidth: 150,
  },
  {
    id: 'preview',
    label: 'Preview',
    maxWidth: 150,
  },
  {
    id: 'NextInvoiceNumber',
    label: 'Last used V.No.',
    maxWidth: 150,
  },
  {
    id: 'taxability',
    label: 'Taxability',
    maxWidth: 150,
  },
  {
    id: 'actions',
    label: 'Actions',
    maxWidth: 100,
  },
];

export const ManualDefault = [
  {
    Title: '',
    ApplicableFrom: 1,
    ApplicableTo: 1,
    ID: 1,
    SerialIsActive: 0,
    Prefix: '',
    NextInvoiceNumber: -1,
    Suffix: '',
    Preview: '',
  },
];

export const dataSections = [
  {
    sectionHeading: 'Item Settings',
    sectionSubHeading: 'Item code',
    rows: [[createData(1, 'A', 101, 'B', 'A101B')]],
  },
  {
    sectionHeading: 'Service Settings',
    sectionSubHeading: 'Service code',
    rows: [[createData(1, 'A', 101, 'B', 'A101B')]],
  },
];

function createData(id, prefix, start, suffix, preview) {
  return { id, prefix, start, suffix, preview };
}

// export const settingsrows = [createData(1, "A", 101, "B", "A101B")];
